import { css } from '@microsoft/fast-element';
import { MainStyles } from '../../../../main/main.styles';
import { mixinRobotoBold, mixinRobotoMedium, mixinRobotoRegular } from '../../../../styles';
import Confirmed from '../../../../assets/confirmed.svg';
import AwaitingConfirmation from '../../../../assets/awaiting-confirmation.svg';

export const ExecutionDrilldownStyles = css`
    ${MainStyles}
    
    :host {
        display: contents;
    }

    .drilldown-wrapper {
        flex: 1;
        border-left: 1px solid #373e45;
        border-radius: 6px;
        box-shadow: -5px 0 5px 0 rgba(0, 0, 0, 0.09);
    }

    .vppa-ticker {
        font-size: 14px;
        line-height: 48px;
        color: var(--white);
        padding-left: 16px;
        ${mixinRobotoMedium()}
    }

    .isNegotiationDetails {
        overflow: auto;
        max-height: calc(100% - 60px);
    }

    .isNegotiationDetails .table-contents,
    .isNegotiationDetails .header-column > div,
    .isNegotiationDetails .value-column > div {
        width: auto;
    }

    .table-contents {
        display: flex;
        width: 510px;
    }

    .header-column, .value-column {
        display: flex;
        flex-direction: column;
        border-top: 1px solid #373e45;
    }

    .value-column {
        flex: 1;
        max-width: 300px;
    }

    .header-column {
        flex: 1;
        width: 330px;
    }

    .header-column > div, 
    .value-column > div {
        font-size: 11px;
        line-height: 30px;
        padding: 0 10px;
        border-color: #373e45;
        border-style: solid;ZX
    }

    .header-column > div {
        text-align: right;
        color: var(--gray-lighter);
        border-width: 0 1px 1px 0;
        background-color: rgba(242, 242, 242, 0.02);
        width: 215px;
        ${mixinRobotoBold}
        
    }

    .value-column > div {
        flex: 1;
        color: var(--nest-level-tab-font);
        border-width: 0 0 1px 0;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        width: 318px;
        ${mixinRobotoRegular}
    }

    .value-column .awaiting-confirmation {
        padding-left: 30px;
        background: url(${AwaitingConfirmation}) no-repeat 10px center;
    }

    .value-column .confirmed {
        padding-left: 30px;
        background: url(${Confirmed}) no-repeat 10px center;
    }

    .warning-message {
        font-size: 12px;
        color: var(--error);
        padding: 16px;
        ${mixinRobotoRegular}
    }

    .button-wrapper {
        display: flex;
        gap: 10px;
        justify-content: flex-end;
        padding: 16px 16px 16px 0;
    }

    .button-wrapper.margin-top-long {
        margin-top: 116px;
    }

    .header-wrapper {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        padding-right: 5px;
    }
`;
